// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from 'lodash/get';

const styles = ({ color, margin, padding, theme }) => ({
  pageSettings: {
    padding: `0 ${get(padding, 'p36')}`,
    width: '900px',
  },
  topContainer: {
    display: 'flex',
  },
  deleteContainer: {
    marginLeft: 'auto',
    marginTop: '30px',
    marginRight: '30px',
  },
  pageTitle: {
    margin: `${get(margin, 'm5')} 0`,
    wordWrap: 'break-word',
    paddingTop: `${get(padding, 'p5')} 0`,
  },
  pageFooter: {
    margin: `${get(margin, 'm5')} 0`,
    wordWrap: 'break-word',
    paddingTop: `${get(padding, 'p5')} 0`,
  },
  closeIcon: {
    marginTop: `${get(padding, 'p20')}`,
    border: '1px solid ',
    borderColor: get(color, 'primaryButtonBackground'),
    marginLeft: get(margin, 'm10'),
    borderRadius: '4px',
    height: '30px',
    width: '30px',
  },
  textFieldContainer: {
    marginTop: `33px !important`,
  },
  textFieldContainer2: {
    marginTop: `-20px !important`,
  },
  textFieldContainer3: {
    marginTop: `33px !important`,
    border: '0px !important',
  },
  deleteButton: {
    textTransform: 'none',
    color: `${get(color, 'error')} !important`,
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: `${get(color, 'error')} !important`,
    marginLeft: 'auto',
    float: 'right',
    display: 'inline-flex',
    height: 'fit-content',
    padding: '3px 15px',
    marginTop: '15px',
  },
  deleteConfirmContainer: {
    display: 'inline-flex',
    marginLeft: 'auto',
    marginTop: '15px',
  },
  cancelIcon: {
    marginLeft: 3,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  errorBackgroundButton: {
    backgroundColor: get(color, 'error'),
    color: get(color, 'bodyBackground'),
    '&:hover': {
      backgroundColor: get(color, 'borderColor'),
    },
    '&:focus': {
      backgroundColor: get(color, 'borderColor'),
    },
  },
  cancelButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    lineHeight: get(theme, 'lineHeight.lh20'),
  },
  saveContainer: {
    float: 'right',
    paddingLeft: '30px',
    paddingRight: '24px',
  },
  saveButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    float: 'left',
    marginRight: '10px',
    lineHeight: get(theme, 'lineHeight.lh20'),
  },
  saveButtonForce: {
    textTransform: 'none',
    color: `${get(theme, 'color.primaryButtonText')} !important`,
    backgroundColor: `${get(color, 'warning')} !important`,
    borderColor: `${get(color, 'warning')} !important`,
    float: 'left',
    marginRight: '10px',
    lineHeight: get(theme, 'lineHeight.lh20'),
  },

  gridContainer: {
    display: 'inline-flex',
    width: '100%',
    paddingLeft: 36,
    marginTop: "3rem",
  },
  divider: {
    backgroundColor: get(theme, 'color.bodyText'),
  },
  bodyContent: {
    display: 'block',
  },
  contentPadding: {
    padding: '0px 36px',
  },
  messageContainer: {
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: '30px',
    minHeight: '40px',
    top: '40px !important',
    position: 'fixed',
    zIndex: get(theme, 'zIndex.snackbar'),
    marginLeft: '-20px',
    width: '875px !important',
  },
  helpIconContainer: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  moreInfoAlertMessage: {
    minWidth: 'fit-content',
    width: 'max-content',
    left: '35% !important',
    backgroundColor: get(color, 'white'),
    color: get(color, 'black'),
    fontWeight: 800,
    '& .MuiSnackbarContent-message': {
      width: 'fit-content',
    },
  },
  moreInfoAlertMessagesCloseButton: {
    color: get(color, 'primaryButtonBackground'),
  },
  linkFieldContainer: {
    paddingLeft : '5px !important',
    cursor: 'pointer',
  },

  errorContainer: {
    borderRadius: 8,
    maxWidth: '100%',
    padding: 24,
    marginBottom: 10,
    overflow: 'auto',
    minHeight: '452px',
    marginTop: 1,
  },
  errorPadding: {
    marginBottom: 20,
    maxWidth: '95%',
  },
  errorTitle: {
    color: get(theme, 'color.bodyText'),
    display: 'inline-block',
    fontFamily: 'ca-sans-light',
    fontSize: 24,
    marginLeft: 14,
    marginTop: 0,
  },
  moreInfoFootNote: {
    display: 'flex',
    color: `${get(color, 'black')} !important`,
    gap: 8,
  },
  errorIcon: {
    fontSize: 24,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    color: `${get(color, 'warning')} !important`,
    padding: 2,
  },
});

export default styles;
